import Apilogs from './apilogs'

export default [
  { path: '/apilogs', name: 'apilogs', component: Apilogs }
]



// WEBPACK FOOTER //
// ./src/components/apilogs/routes.js